import { render, staticRenderFns } from "./SessionTimeouts.vue?vue&type=template&id=a45f9920&scoped=true&"
import script from "./SessionTimeouts.vue?vue&type=script&lang=js&"
export * from "./SessionTimeouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45f9920",
  null
  
)

export default component.exports